import { render } from "./TablePaginationToolbar.vue?vue&type=template&id=33c1d8e5"
import script from "./TablePaginationToolbar.vue?vue&type=script&lang=js"
export * from "./TablePaginationToolbar.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__